import { Typography } from '@material-tailwind/react'

export const ResultHeader = ({ displayDoc, fullName, employeeRole, companyName, contractLabel, message }) => (
  <>
    {displayDoc && <Typography className="text-xl font-medium text-inherit">{displayDoc}</Typography>}
    {fullName && <Typography className="text-lg text-inherit">{fullName}</Typography>}
    {employeeRole && <Typography className="text-base text-inherit">{employeeRole}</Typography>}
    {companyName && <Typography className="text-lg text-inherit">{companyName}</Typography>}
    {contractLabel && <Typography className="text-base text-inherit">{contractLabel}</Typography>}
    <Typography className="text-2xl font-bold underline text-inherit">{message}</Typography>
  </>
)
